import { render, staticRenderFns } from "./ProgramDetailMenu.vue?vue&type=template&id=09168b69&scoped=true&"
import script from "./ProgramDetailMenu.vue?vue&type=script&lang=js&"
export * from "./ProgramDetailMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetailMenu.vue?vue&type=style&index=0&id=09168b69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09168b69",
  null
  
)

export default component.exports